import { render, staticRenderFns } from "./importBase.vue?vue&type=template&id=607e1af8"
import script from "./importBase.vue?vue&type=script&lang=js"
export * from "./importBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports